import React from "react";
import ReactDOM from "react-dom";
import App from './App';


const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);



// WEBPACK FOOTER //
// ./src/index.js